module.exports = __webpack_public_path__ + "img/tiktok.8ab0c96b.svg";